import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import button from '@/components/button'
import confirmButtonDialog from '@/components/button/confirm/dialog'

function renderHint(h) {
  if (this.showDescription) {
    return h(
      'div',
      {
        class: 'settings-fields__description'
      },
      [ this.description ]
    )
  }

  return h('div')
}
function renderConfirmDialog(h) {
  return h(
    confirmButtonDialog,
    {
      props: {
        value: this.showDialog,
        title: this.label,
        callback: () => {
          this.$emit('input', true)
          this.showDialog = false
        }
      }
    }
  )
}
function renderButton(h) {
  if (this.options.permission && [ 'default', 'write' ].includes(this.options.permission)) {
    return h(
      button,
      {
        props: {
          label: this.getTranslate('misc.buttons.save'),
          icon: icons.save,
          mode: buttonModes.flat,
          color: Colors.primary,
          loading: this.options.loading.update[this.options.path],
          disabled: this.disabled
        },
        scopedSlots: {
          dialog: () => {
            return renderConfirmDialog.call(this, h)
          }
        },
        on: {
          click: () => {
            if (this.dialog) {
              this.showDialog = true
            } else {
              this.$emit('input', true)
            }
          }
        }
      }
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: 'settings-fields__footer'
    },
    [
      renderHint.call(this, h),
      renderButton.call(this, h)
    ]
  )
}
